// Wallet preferences settings strings — EN + TR.
//
// Wave-2 Day 1. Auto-withdraw threshold + statement cadence + default payout
// method + wallet notifications. Volkan direction 2026-05-23 (Settings
// 10-section expansion item #6).
//
// Operational values (e.g. '$500.00', 'ACH · Chase ****4218',
// 'Weekly · Mondays 9:00 EST') preserved as proper-noun-style data; only
// chrome translates.
//
// Source: features/settings/WalletPreferences.tsx.

import type { LocalizedDict } from '../index'

type WalletPreferencesStrings = {
  pageTitle: string
  pageDescriptionLead: string
  pageDescriptionWalletKeyword: string
  pageDescriptionTail: string
  footerNote: string
  toastTail: string
  walletShortcut: {
    title: string
    description: string
    action: string
    toastTitle: string
    toastDescription: string
  }
  actions: {
    change: string
  }
  preferences: {
    autoWithdraw: { label: string; description: string }
    statementCadence: { label: string; description: string }
    payoutMethod: { label: string; description: string }
    notifications: { label: string; description: string; enabled: string }
  }
}

export const walletPreferencesI18n: LocalizedDict<WalletPreferencesStrings> = {
  en: {
    pageTitle: 'Wallet preferences',
    pageDescriptionLead:
      'Configure your payout cadence, thresholds, and notifications. Wallet operations themselves live in the ',
    pageDescriptionWalletKeyword: 'Wallet',
    pageDescriptionTail: ' sidebar surface.',
    footerNote:
      'Placeholder section · backend persistence M3 Stage 4 SPEC.md Faz 4 (Wallets + Settlement).',
    toastTail:
      'Preference persistence M3 Stage 4 SPEC.md Faz 4 (Wallets + Settlement).',
    walletShortcut: {
      title: 'Looking for your balance or statements?',
      description:
        'Open the Wallet menu in the sidebar — Balance / Referrals / Banking submenu wires the active operations surface. This Settings page only hosts preferences.',
      action: 'Open Wallet',
      toastTitle: 'Wallet sidebar shortcut · mock-only',
      toastDescription: 'Use the sidebar Wallet menu to navigate.',
    },
    actions: {
      change: 'Change',
    },
    preferences: {
      autoWithdraw: {
        label: 'Auto-withdraw threshold',
        description:
          'Trigger automatic payout when wallet balance crosses this floor.',
      },
      statementCadence: {
        label: 'Statement cadence',
        description: 'How often we mail you a settlement summary.',
      },
      payoutMethod: {
        label: 'Default payout method',
        description: 'Banking submenu manages the actual rail wiring.',
      },
      notifications: {
        label: 'Wallet notifications',
        description:
          'Email me on incoming credits, refunds, and threshold breaches.',
        enabled: 'Enabled',
      },
    },
  },
  tr: {
    pageTitle: 'Cüzdan tercihleri',
    pageDescriptionLead:
      'Ödeme aralığı, eşikler ve bildirimleri yapılandır. Cüzdan operasyonlarının kendisi ',
    pageDescriptionWalletKeyword: 'Cüzdan',
    pageDescriptionTail: ' kenar çubuğu yüzeyinde yaşar.',
    footerNote:
      'Yer tutucu bölüm · backend kalıcılığı M3 Stage 4 SPEC.md Faz 4 (Cüzdan + Mutabakat) ile gelir.',
    toastTail:
      'Tercih kalıcılığı M3 Stage 4 SPEC.md Faz 4 (Cüzdan + Mutabakat) ile bağlanır.',
    walletShortcut: {
      title: 'Bakiyeni veya ekstreni mi arıyorsun?',
      description:
        'Kenar çubuğundaki Cüzdan menüsünü aç — Bakiye / Referanslar / Banka alt menüsü aktif operasyon yüzeyini sağlar. Bu Ayarlar sayfası yalnız tercihleri barındırır.',
      action: 'Cüzdanı aç',
      toastTitle: 'Cüzdan kenar çubuğu kısayolu · sadece mock',
      toastDescription:
        'Gezinmek için kenar çubuğundaki Cüzdan menüsünü kullan.',
    },
    actions: {
      change: 'Değiştir',
    },
    preferences: {
      autoWithdraw: {
        label: 'Otomatik çekim eşiği',
        description:
          'Cüzdan bakiyesi bu tabanı geçtiğinde otomatik ödemeyi tetikle.',
      },
      statementCadence: {
        label: 'Ekstre periyodu',
        description: 'Mutabakat özetini sana ne sıklıkla göndereceğimiz.',
      },
      payoutMethod: {
        label: 'Varsayılan ödeme yöntemi',
        description:
          'Asıl hat bağlamasını Banka alt menüsü yönetir.',
      },
      notifications: {
        label: 'Cüzdan bildirimleri',
        description:
          'Gelen kredi, iade ve eşik ihlallerinde bana e-posta gönder.',
        enabled: 'Açık',
      },
    },
  },
}
